// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  PackageSelectionCardCoachFragmentDoc,
  PackageSelectionCardOfferingPackageFragmentDoc,
} from './PackageSelectionCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PackageSelectionCoachFragment = {
  __typename?: 'Coach';
  id: string;
  tier: Types.SkuTier;
};

export type PackageSelectionOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  name: string;
  slug?: string | null;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    tier?: Types.SkuTier | null;
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
};

export type PackageSelectionLelandPackagesQueryVariables = Types.Exact<{
  categoryUrn: Types.Scalars['CategoryUrn']['input'];
  tier: Types.SkuTier;
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type PackageSelectionLelandPackagesQuery = {
  __typename?: 'Query';
  lelandPackages: {
    __typename?: 'PackageSearchResponse';
    results: Array<{
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      slug?: string | null;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        tier?: Types.SkuTier | null;
        sku?: string | null;
        price: number;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
    }>;
  };
};

export const PackageSelectionCoachFragmentDoc = gql`
  fragment PackageSelection_Coach on Coach {
    id
    ...PackageSelectionCard_Coach
  }
  ${PackageSelectionCardCoachFragmentDoc}
`;
export const PackageSelectionOfferingPackageFragmentDoc = gql`
  fragment PackageSelection_OfferingPackage on OfferingPackage {
    id
    prices {
      tier
      sku
    }
    ...PackageSelectionCard_OfferingPackage
  }
  ${PackageSelectionCardOfferingPackageFragmentDoc}
`;
export const PackageSelectionLelandPackagesDocument = gql`
  query PackageSelection_LelandPackages(
    $categoryUrn: CategoryUrn!
    $tier: SkuTier!
    $coachUrn: CoachUrn!
  ) {
    lelandPackages(
      categoryUrn: $categoryUrn
      coachUrn: $coachUrn
      tier: $tier
      status: LIVE
      visibility: PUBLIC
      srpView: false
    ) {
      results {
        ...PackageSelection_OfferingPackage
      }
    }
  }
  ${PackageSelectionOfferingPackageFragmentDoc}
`;

/**
 * __usePackageSelectionLelandPackagesQuery__
 *
 * To run a query within a React component, call `usePackageSelectionLelandPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageSelectionLelandPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageSelectionLelandPackagesQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *      tier: // value for 'tier'
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function usePackageSelectionLelandPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    PackageSelectionLelandPackagesQuery,
    PackageSelectionLelandPackagesQueryVariables
  > &
    (
      | {
          variables: PackageSelectionLelandPackagesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PackageSelectionLelandPackagesQuery,
    PackageSelectionLelandPackagesQueryVariables
  >(PackageSelectionLelandPackagesDocument, options);
}
export function usePackageSelectionLelandPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PackageSelectionLelandPackagesQuery,
    PackageSelectionLelandPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PackageSelectionLelandPackagesQuery,
    PackageSelectionLelandPackagesQueryVariables
  >(PackageSelectionLelandPackagesDocument, options);
}
export function usePackageSelectionLelandPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PackageSelectionLelandPackagesQuery,
        PackageSelectionLelandPackagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PackageSelectionLelandPackagesQuery,
    PackageSelectionLelandPackagesQueryVariables
  >(PackageSelectionLelandPackagesDocument, options);
}
export type PackageSelectionLelandPackagesQueryHookResult = ReturnType<
  typeof usePackageSelectionLelandPackagesQuery
>;
export type PackageSelectionLelandPackagesLazyQueryHookResult = ReturnType<
  typeof usePackageSelectionLelandPackagesLazyQuery
>;
export type PackageSelectionLelandPackagesSuspenseQueryHookResult = ReturnType<
  typeof usePackageSelectionLelandPackagesSuspenseQuery
>;
export type PackageSelectionLelandPackagesQueryResult = Apollo.QueryResult<
  PackageSelectionLelandPackagesQuery,
  PackageSelectionLelandPackagesQueryVariables
>;
